import { AsyncThunk, createAsyncThunk } from '@reduxjs/toolkit';
import { AxiosResponse } from 'axios';

import { axiosInstance } from '../../shared/api/axios-instance';
import { Endpoints } from '../../shared/utils/endpoints-file.utils';
import { WebGameRequestDto } from '../dtos/web-game-request.dto';
import { WebGameResponseDto } from '../dtos/web-game-response.dto';
import { WebGameRequestModel } from '../models/web-game-request.model';
import { WebGameResponseModel } from '../models/web-game-response.model';
import {
  mapWebGameRequestModelToWebGameRequestDto,
  mapWebGameResponseDtoToWebGameResponseModel,
} from '../utils/mapping.util';

export const createWebGame: AsyncThunk<
  WebGameResponseModel,
  WebGameRequestModel,
  Record<string, unknown>
> = createAsyncThunk<
  WebGameResponseModel,
  WebGameRequestModel,
  Record<string, unknown>
>('web-games/add-web-game', async (gameBody): Promise<WebGameResponseModel> => {
  const gameDto: WebGameRequestDto =
    mapWebGameRequestModelToWebGameRequestDto(gameBody);

  const { data }: AxiosResponse<WebGameResponseDto> = await axiosInstance.post(
    Endpoints.WEB_GAMES,
    gameDto,
    {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    }
  );
  return mapWebGameResponseDtoToWebGameResponseModel(data);
});
